import Lang from 'libraries/Lang';

const getTimes = () => {
    const times = [];

    times.push({
        value: '',
        isDisabled: true,
        text: `-${Lang.trans('engine_cars.morning')}-`,
    });

    for (let h = 0; h < 24; h += 1) {
        const meridian = h < 12 ? 'am' : 'pm';

        if (h === 12) {
            times.push({
                value: '',
                isDisabled: true,
                text: `-${Lang.trans('engine_cars.afternoon')}-`,
            });
        }

        if (h === 18) {
            times.push({
                value: '',
                isDisabled: true,
                text: `-${Lang.trans('engine_cars.evening')}-`,
            });
        }

        for (let m = 0; m < 60; m += 30) {
            let twelveHour = (h > 12) ? h - 12 : h;
            /*if (twelveHour === 0) {
                twelveHour = 12;
            }*/

            if (twelveHour === 12) twelveHour = 0;
            twelveHour = (twelveHour < 10) ? `0${twelveHour}` : twelveHour;

            const hour = (h < 10) ? `0${h}` : h;
            const minute = (m === 0) ? '00' : m;
            const timeTwentyFour = [hour, minute].join(':');
            const timeTwelve = [twelveHour, minute].join(':');
            const text = [timeTwelve, meridian].join(' ');

            const ob = {
                value: timeTwentyFour,
                text,
            };
            times.push(ob);
        }
    }
     
    return times;
}

export { getTimes }
